import {useQueryClient} from 'react-query'
import {QUERIES} from '../../../../helpers'
import {IWebsite} from '../../../../../app/pages/websites/core/_models'
import {AsideMenuItem} from '../AsideMenuItem'
import {AsideMenuItemWithSub} from '../AsideMenuItemWithSub'
import {FormattedMessage} from 'react-intl'
import {useMenuPermission} from '../../../../helpers/hooks/menuHook'
import {useAuth} from '../../../../../app/modules/auth'
import {useEffect} from 'react'

const WebsitesMenu = () => {
  const {setAuthReferer, currentUser} = useAuth()
  const queryClient = useQueryClient()
  const websitesData: IWebsite[] = queryClient.getQueryData(QUERIES.WEBSITES_LIST) || []

  useEffect(() => {
    const userWebsites: IWebsite[] | undefined = websitesData?.filter((website) => currentUser?.websites?.some((userWebsite) => userWebsite.id === website.id))
    if(userWebsites?.length){
      setAuthReferer('https://my.'+userWebsites[0].host);
    }
  }, [websitesData])
  const menuItems = [
    {
      to: '/websites',
      icon: '/media/icons/duotune/communication/com001.svg',
      title: 'GENERAL.ASIDE_MENU.WEBSITES_LIST_TITLE',
      fontIcon: 'bi-layers',
    },
    {
      to: '/websites/translation',
      title: 'GENERAL.ASIDE_MENU.WEBSITES_TRANSLATION_TITLE',
      fontIcon: 'bi-sticky',
      icon: '/media/icons/duotune/maps/map004.svg',
      subItems: websitesData?.map((item) => ({
        key: item.id,
        to: `/websites/translation/${item.id}/list`,
        title: item.name || item.host,
        hasBullet: true,
        translate: false,
      })),
    },
    {
      to: '/websites/forms',
      icon: '/media/icons/duotune/general/gen005.svg',
      title: 'GENERAL.ASIDE_MENU.WEBSITES_FORMS_TITLE',
      fontIcon: 'bi-sticky',
      subItems: websitesData
        ?.filter((item) => item.websiteForms.length > 0)
        .map((item) => ({
          key: item.id,
          to: `/websites/forms/list/${item.id}`,
          title: item.name || item.host,
          hasBullet: true,
          translate: false,
        })),
    },
    {
      to: '/websites/pages',
      icon: '/media/icons/duotune/layouts/lay009.svg',
      title: 'GENERAL.ASIDE_MENU.WEBSITES_PAGES_TITLE',
      fontIcon: 'bi-sticky',
      subItems: websitesData
        ?.filter((item) => item.websitePages?.length > 0)
        .map((item) => ({
          key: item.id,
          to: `/websites/pages/list/${item.id}`,
          title: item.name || item.host,
          hasBullet: true,
          translate: false,
        })),
    },
    {
      to: '/blog',
      icon: '/media/icons/duotune/art/art008.svg',
      title: 'GENERAL.ASIDE_MENU.WEBSITES_BLOG_TITLE',
      fontIcon: 'bi-layers',
      subItems: [
        {
          to: `/blog`,
          title: 'GENERAL.ASIDE_MENU.WEBSITES_LIST_TITLE',
          hasBullet: true,
        },
        {
          to: `/website-categories/blog`,
          title: 'GENERAL.ASIDE_MENU.WEBSITES_CATEGORIES_TITLE',
          hasBullet: true,
        },
      ],
    },
    {
      to: '/stores',
      icon: '/media/icons/duotune/ecommerce/ecm002.svg',
      title: 'GENERAL.ASIDE_MENU.WEBSITES_STORES_TITLE',
      fontIcon: 'bi-layers',
      subItems: [
        {
          to: `/stores`,
          title: 'GENERAL.ASIDE_MENU.WEBSITES_LIST_TITLE',
          hasBullet: true,
        },
        {
          to: `/website-categories/stores`,
          title: 'GENERAL.ASIDE_MENU.WEBSITES_CATEGORIES_TITLE',
          hasBullet: true,
        },
        {
          to: `/website-collections/stores`,
          title: 'GENERAL.ASIDE_MENU.WEBSITES_COLLECTIONS_TITLE',
          hasBullet: true,
        },
        {
          to: '/sgoods',
          title: 'GENERAL.ASIDE_MENU.WEBSITES_STORE_GOODS_TITLE',
          hasBullet: true,
        },
      ],
    },
  ]

  const {filterMenuItems, isMenuItemAllowed} = useMenuPermission()
  return (
    <>
      {isMenuItemAllowed('GENERAL.ASIDE_MENU.WEBSITES_SECTION') && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-uppercase fs-8 ls-1 text-gray-300 fw-bold'>
                <FormattedMessage id='GENERAL.ASIDE_MENU.WEBSITES_SECTION' />
              </span>
            </div>
          </div>

          {filterMenuItems(menuItems).map((item, index) =>
            item.subItems ? (
              <AsideMenuItemWithSub
                key={index}
                to={item.to}
                title={item.title}
                fontIcon={item.fontIcon}
                icon={item.icon}
              >
                {item.subItems.map((subItem, subIndex) => (
                  <AsideMenuItem
                    key={subIndex}
                    to={subItem.to}
                    title={subItem.title}
                    hasBullet={subItem.hasBullet}
                    // @ts-ignore
                    translate={subItem?.translate}
                  />
                ))}
              </AsideMenuItemWithSub>
            ) : (
              <AsideMenuItem
                key={index}
                to={item.to}
                icon={item.icon}
                title={item.title}
                fontIcon={item.fontIcon}
              />
            )
          )}
        </>
      )}
    </>
  )
}

export default WebsitesMenu
